import { createReducer, on } from "@ngrx/store";
import { initialState } from "./user.state";
import * as UserActions from "./user.actions";

export const userReducer = createReducer(
    initialState,
    on(UserActions.findUsersSuccess, (state, { users }) => ({
        ...state,
        userResult: users,
        error: null
    })),
    on(UserActions.findUsersError, (state, { error }) => ({
        ...state,
        error
    }))
);
